import React from 'react';
// import {  Nav, NavItem } from 'reactstrap';

function Footer(props) {
  return (
    <div className="container p-0">
      <footer className="m-0">
        <div className={props.portal.footer.class ? props.portal.footer.class : "footer m-0"}>

          <div className="row justify-content-center">
            <div className="col" align="center">
            <a href={props.portal.url} target="_blank" rel="noopener noreferrer">
              <img
                src={props.portal.imgUrlLogoBtm ? props.portal.imgUrlLogoBtm : props.portal.imgUrlLogo}
                alt="Logo"
                className="img-fluid mx-auto p-4"
                style={{ maxWidth: "50%" }}
              />
            </a>
            </div>
          </div>

          <div className="row justify-content-center m-4">
            {props.portal.footer.links_top.map((link) => (
              <div className="col-auto" key={link.key}>
                <p className="h6">
                  {"Bei Fragen oder Problemen wenden Sie sich gerne an unseren "}
                  <a href={"mailto:kunde@lensingmedia.de"} target="_blank" rel="noopener noreferrer">
                    {"Leserservice"}{" "}
                  </a>
                </p>
              </div>
            ))}
          </div>
          <hr />
          <div className="row justify-content-center m-4">
            {props.portal.footer.links_bottom.map((link) => (
              <div className="col-auto" key={link.key}>
                {" "}
                <a href={link.url} target="_blank" rel="noopener noreferrer">
                  {" "}
                  {link.text}{" "}
                </a>
              </div>
            ))}
          </div>
          <div className="text-center small copyright">
            ©{props.year} {props.portal.footer.copyright}
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Footer;